document.addEventListener('turbolinks:load', () => {
    const currentTextSize = document.getElementById('currentTextSize')
    let textSizeModifier = 1 // 1.75 | 1.4 | 1
    const sgScreen = document.getElementById('sgScreen')
    const sgScreenGuest = document.getElementById('sgScreenGuest')
    const textSizeAdjustable = document.getElementById('textSizeAdjustable')
    // textSizeChangeable is true for selfguided screens and onboarding screens. Controller prevents textSizeModifier != 1 in guided mode
    let textSizeChangeable = textSizeAdjustable !== null && textSizeAdjustable.value === "true"
    const sgScreenPrimaryFont = document.getElementById('sgScreenPrimaryFont')

    // used in guided status bar
    const sgPreviewClock = document.getElementById('sgPreviewClock')

    if (sgScreen !== null) {
        if (currentTextSize != null && textSizeChangeable){ //text size can only be modified for selected screens (all selfguided and onboarding in dynamic)
            if (currentTextSize.value === "very large") {
                textSizeModifier = 1.75
            } else if (currentTextSize.value === "large") {
                textSizeModifier = 1.4
            }
        }
        let fontUrl = ""
        if (sgScreenPrimaryFont !== null) {
            fontUrl = sgScreenPrimaryFont.value
        }

        //In guided mode, the guest screen should get scaled and the font is only used for the guest
        // The textSize only matters in dynamic mode
        if(sgScreenGuest !== null){
            resize(sgScreen, 1)
            resize(sgScreenGuest, textSizeModifier) //guest screens without changeable text size have a constant textSizeModifier=1 from initialization
            applyDynamicFontToElement(fontUrl, sgScreenGuest)
        } else {
            // selfguided is using the font and textSizeModifier
            resize(sgScreen, textSizeModifier)
            applyDynamicFontToElement(fontUrl, sgScreen)
        }

        if (sgPreviewClock){
            // Initialize Clock
            updateTime(sgPreviewClock)
            // Update Clock every 10 seconds
            setInterval(() => updateTime(sgPreviewClock), 10000)
        }

    }

    //Change the --screen-height property if the width isn't enough to contain the preview
    //Border and screen of the depends on the --screen-height value
    function resizeContainer(screen){
        const defaultHeight = 68.85
        const sgPreviewArea = screen.parentElement
        //Use container for the size checking, cause the sgPreviewArea could get rotated and then swaps width and height
        const sgPreviewContainer = sgPreviewArea.parentElement
        let areaWidth = sgPreviewContainer.getBoundingClientRect().width
        let areaHeight = sgPreviewContainer.getBoundingClientRect().height
        if(sgPreviewArea.classList.contains('rotate-270')){
            //move the area with translate to prevent overlapping areas because of rotation
            let overlapMargin = (areaHeight - areaWidth) / 2
            if (overlapMargin > 0){
                sgPreviewArea.style.transform = `translate(${overlapMargin}px,${overlapMargin}px)`;
            } else {
                sgPreviewArea.style.transform = `translate(${0}px,${overlapMargin}px)`;
            }

            //In guided mode landscape areas are twice as wide as normal areas
            // To have the same scaling in portrait and landscape mode, only use half of the width
            areaWidth = areaWidth / 2
        }
        if (areaWidth < (areaHeight/2)){
            let scaleFactor = areaWidth / (areaHeight/2)
            sgPreviewArea.style.setProperty('--screen-height', (defaultHeight*scaleFactor))
        } else {
            sgPreviewArea.style.setProperty('--screen-height', defaultHeight)
        }
    }

    // resize all texts, svgs ..., based on current screen size.
    // usedTextSize is 1 for guided screens and most guest screens. It could be != 1 for security_notices and headphone_hint in dynamic mode
    function resize(screen, usedTextSize) {
        const texts = screen.getElementsByTagName('p')
        const svgs = screen.getElementsByTagName('svg')
        const buttons = screen.getElementsByTagName('button')
        const radioButtons = screen.getElementsByClassName('myTourAppRadioButton')
        const checkBoxes = screen.getElementsByClassName('myTourQuizCheckBox')
        const roundedBorders = screen.getElementsByClassName('roundedBorders')

        let resizeObserver = new ResizeObserver(() => {
            resizeContainer(screen)
            //Take bigger side of screen as reference to have the same scaling in portrait and landscape mode
            const currentSgScreenHeight = Math.max(screen.getBoundingClientRect().height, screen.getBoundingClientRect().width)

            // texts
            for (let t of texts) {
                let fontSize = 0
                let lineHeight = 0

                if (t.classList.contains('text-3xs')) {
                    fontSize = currentSgScreenHeight / 65
                    lineHeight = currentSgScreenHeight / 65
                } else if (t.classList.contains('text-2xs')) {
                    fontSize = currentSgScreenHeight / 60
                    lineHeight = currentSgScreenHeight / 60
                } else if (t.classList.contains('text-xs')) {
                    fontSize = currentSgScreenHeight / 55
                    lineHeight = currentSgScreenHeight / 55
                } else if (t.classList.contains('text-sm')) {
                    fontSize = currentSgScreenHeight / 52
                    if (t.classList.contains('leading-more-relaxed')) {
                        lineHeight = currentSgScreenHeight / 42
                    } else {
                        lineHeight = currentSgScreenHeight / 52
                    }
                } else if (t.classList.contains('text-base')) {
                    fontSize = currentSgScreenHeight / 48
                    lineHeight = currentSgScreenHeight / 48
                } else if(t.classList.contains('text-lg')) {
                    fontSize = currentSgScreenHeight / 42
                    if (t.classList.contains('leading-relaxed')) {
                        lineHeight = currentSgScreenHeight / 35
                    }else if(t.classList.contains('leading-more-relaxed')){
                        lineHeight = currentSgScreenHeight / 27 // same as trix-content line height
                    } else {
                        lineHeight = currentSgScreenHeight / 42
                    }
                } else if (t.classList.contains('text-xl')) {
                    fontSize = currentSgScreenHeight / 30
                    if (t.classList.contains('leading-relaxed')) {
                        lineHeight = currentSgScreenHeight / 25
                    } else {
                        lineHeight = currentSgScreenHeight / 30
                    }
                } else if (t.classList.contains('text-2xl')) {
                    fontSize = currentSgScreenHeight / 25
                    if (t.classList.contains('line-height-m')) {
                        lineHeight = currentSgScreenHeight / 17
                    } else if (t.classList.contains('line-height-s')) {
                        lineHeight = currentSgScreenHeight / 18
                    } else {
                        lineHeight = currentSgScreenHeight / 25
                    }
                } else if (t.classList.contains('text-3xl')) {
                    fontSize = currentSgScreenHeight / 20
                    if (t.classList.contains('leading-relaxed')) {
                        lineHeight = currentSgScreenHeight / 17
                    } else {
                        lineHeight = currentSgScreenHeight / 20
                    }
                }

                if (!t.classList.contains('ignoreFontScale')) {
                    fontSize *= usedTextSize
                    lineHeight *= usedTextSize
                }

                if (fontSize !== 0) {
                    t.style.fontSize = `${fontSize}px`
                    t.style.lineHeight = `${lineHeight}px`
                }
            }

            // svgs
            for (let s of svgs) {
                if (s.classList.contains('scalable')) {
                    if (s.classList.contains('scaleM')) {
                        s.style.height = `${currentSgScreenHeight * 0.03}px`
                    } else if (s.classList.contains('scaleM2')) {
                        s.style.height = `${currentSgScreenHeight * 0.033}px`
                        s.style.width = `${currentSgScreenHeight * 0.033}px`
                    } else if (s.classList.contains('scaleL')) {
                        s.style.height = `${currentSgScreenHeight * 0.045}px`
                    } else if (s.classList.contains('scaleXL')) {
                        s.style.height = `${currentSgScreenHeight * 0.06}px`
                    } else { //ScaleM if nothing specified
                        s.style.height = `${currentSgScreenHeight * 0.03}px`
                    }
                }
            }

            for (let b of buttons) {
                let fontSize = 0
                let lineHeight = 0
                if (b.classList.contains('text-2xl2')) { //only set in font-size Screen
                    fontSize = currentSgScreenHeight / 23
                    lineHeight = currentSgScreenHeight / 23
                } else if (b.classList.contains('text-xl2')) { //only set in font-size Screen
                    fontSize = currentSgScreenHeight / 28
                    lineHeight = currentSgScreenHeight / 28
                } else if (b.classList.contains('text-lg2')) {
                    fontSize = currentSgScreenHeight / 39
                    lineHeight = currentSgScreenHeight / 39
                } else if (b.classList.contains('text-lg')) {
                    fontSize = currentSgScreenHeight / 42
                    lineHeight = currentSgScreenHeight / 42
                } else if (b.classList.contains('text-base')) {
                    fontSize = currentSgScreenHeight / 48
                    lineHeight = currentSgScreenHeight / 48
                } else if (b.classList.contains('text-xs')) {
                    fontSize = currentSgScreenHeight / 55
                    lineHeight = currentSgScreenHeight / 55
                }

                if (!b.classList.contains('ignoreFontScale')) {
                    fontSize *= usedTextSize
                    lineHeight *= usedTextSize
                }

                if (fontSize !== 0) {
                    b.style.fontSize = `${fontSize}px`
                    b.style.lineHeight = `${lineHeight}px`
                }
            }

            // roundedBorders
            for (let r of roundedBorders) {
                if (r.classList.contains('rounded-b-3xl')) {
                    r.style.borderBottomLeftRadius = `${ currentSgScreenHeight/ 25.0}px`
                    r.style.borderBottomRightRadius = `${ currentSgScreenHeight/ 25.0}px`
                }

                if (r.classList.contains('rounded-2xl')) {
                    r.style.borderTopLeftRadius = `${ currentSgScreenHeight/ 35.0}px`
                    r.style.borderTopRightRadius = `${ currentSgScreenHeight/ 35.0}px`
                    r.style.borderBottomLeftRadius = `${ currentSgScreenHeight/ 35.0}px`
                    r.style.borderBottomRightRadius = `${ currentSgScreenHeight/ 35.0}px`
                }

                if (r.classList.contains('rounded-t-2xl')) {
                    r.style.borderTopLeftRadius = `${ currentSgScreenHeight/ 35.0}px`
                    r.style.borderTopRightRadius = `${ currentSgScreenHeight/ 35.0}px`
                }

                if (r.classList.contains('rounded-xl')) {
                    r.style.borderTopLeftRadius = `${ currentSgScreenHeight/ 45.0}px`
                    r.style.borderTopRightRadius = `${ currentSgScreenHeight/ 45.0}px`
                    r.style.borderBottomLeftRadius = `${ currentSgScreenHeight/ 45.0}px`
                    r.style.borderBottomRightRadius = `${ currentSgScreenHeight/ 45.0}px`
                }

                if (r.classList.contains('rounded-b-xl')) {
                    r.style.borderBottomLeftRadius = `${ currentSgScreenHeight/ 45.0}px`
                    r.style.borderBottomRightRadius = `${ currentSgScreenHeight/ 45.0}px`
                }

                if (r.classList.contains('rounded-t-xl')) {
                    r.style.borderTopLeftRadius = `${ currentSgScreenHeight/ 45.0}px`
                    r.style.borderTopRightRadius = `${ currentSgScreenHeight/ 45.0}px`
                }

                if (r.classList.contains('rounded-lg')) {
                    r.style.borderTopLeftRadius = `${ currentSgScreenHeight/ 60.0}px`
                    r.style.borderTopRightRadius = `${ currentSgScreenHeight/ 60.0}px`
                    r.style.borderBottomLeftRadius = `${ currentSgScreenHeight/ 60.0}px`
                    r.style.borderBottomRightRadius = `${ currentSgScreenHeight/ 60.0}px`
                }

                if (r.classList.contains('rounded-t-lg')) {
                    r.style.borderTopLeftRadius = `${ currentSgScreenHeight/ 60.0}px`
                    r.style.borderTopRightRadius = `${ currentSgScreenHeight/ 60.0}px`
                }

                if (r.classList.contains('rounded-b-lg')) {
                    r.style.borderBottomLeftRadius = `${ currentSgScreenHeight/ 60.0}px`
                    r.style.borderottomRightRadius = `${ currentSgScreenHeight/ 60.0}px`
                }

                if (r.classList.contains('rounded-r-lg')) {
                    r.style.borderTopRightRadius = `${ currentSgScreenHeight/ 60.0}px`
                    r.style.borderBottomRightRadius = `${ currentSgScreenHeight/ 60.0}px`
                }

                if (r.classList.contains('rounded-l-lg')) {
                    r.style.borderTopLeftRadius = `${ currentSgScreenHeight/ 60.0}px`
                    r.style.borderBottomLeftRadius = `${ currentSgScreenHeight/ 60.0}px`
                }

                if (r.classList.contains('rounded-sm')) {
                    r.style.borderTopLeftRadius = `${ currentSgScreenHeight/ 200.0}px`
                    r.style.borderTopRightRadius = `${ currentSgScreenHeight/ 200.0}px`
                    r.style.borderBottomLeftRadius = `${ currentSgScreenHeight/ 200.0}px`
                    r.style.borderBottomRightRadius = `${ currentSgScreenHeight/ 200.0}px`
                }
            }

            // radio
            for (let r of radioButtons) {
                if(document.getElementById('selfGuidedQuizStationScreenPreview') !== null){ //different size than usual
                    r.style.width = `${currentSgScreenHeight *0.030}px`
                    r.style.height = `${currentSgScreenHeight *0.030}px`
                } else {
                    r.style.width = `${currentSgScreenHeight *0.035}px`
                    r.style.height = `${currentSgScreenHeight *0.035}px`
                }
            }

            // checkboxes
            for (let c of checkBoxes) {
                c.style.width = `${currentSgScreenHeight/39.98}px`;
                c.style.height = `${currentSgScreenHeight/39.98}px`;
                c.style.borderWidth =  `${currentSgScreenHeight/275}px`;
            }

            handleHorizontalTextScroll(screen)
        })
        //Screen only has a percentage of the height, so width don't change with changing the window size
        //To observe width changes too, observe the parent
        resizeObserver.observe(screen.parentElement);
    }

    // handle scroll of area and tour name
    function handleHorizontalTextScroll(screen) {
        // get all scrollable elements
        const texts = screen.getElementsByClassName('horizontalTextScrollMyTourAppPreview')

        if(texts.length > 0) { //only use function if there are texts
            setTimeout(function () {
                for (let text of texts) {
                    const textWidth = text.getBoundingClientRect().width
                    const parentWidth = text.parentNode.getBoundingClientRect().width
                    // enable scroll if text is longer than parent div
                    if (textWidth > parentWidth && !text.classList.contains('clone') && !text.classList.contains('cloned')) {

                        // horizontal centering of area name must be removed for smooth scrolling
                        if (text.classList.contains("areaName")) {
                            text.parentNode.classList.remove('justify-center')
                        }

                        // add empty space after text
                        text.insertAdjacentHTML('beforeend', '&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp')
                        // enable scroll through class
                        text.classList.add('horizontalTextScrollMyTourAppPreviewAnimation')
                        // change animation time depending on text length
                        text.style.animationDuration = `${textWidth / 33}s`
                        // clone text to allow seamless loop
                        const clonedNote = text.cloneNode(true)
                        clonedNote.classList.add('clone')
                        text.classList.add('cloned')
                        text.parentNode.appendChild(clonedNote)
                    }
                }
            }, 1000);
        }
    }

    async function applyDynamicFontToElement(fontUrl, element) {
        if (fontUrl === ""){
            console.log(`Keine Schriftart verwendet`)
            return
        }
        const fontName = "DynamischerFont"

        // Format automatisch aus der Dateiendung bestimmen
        const getFontFormat = (url) => {
            if (url.endsWith(".woff2")) return "woff2"
            if (url.endsWith(".woff"))  return "woff"
            if (url.endsWith(".ttf"))   return "truetype"
            if (url.endsWith(".otf"))   return "opentype"
            return null
        };

        const format = getFontFormat(fontUrl)

        if (!format) {
            console.warn(`Unbekanntes Font-Format für URL: ${fontUrl}`)
            return
        }

        try {
            // FontFace mit explizitem Format erstellen
            const font = new FontFace(fontName, `url(${fontUrl}) format('${format}')`)

            await font.load();
            document.fonts.add(font)

            if (element) {
                element.style.fontFamily = `'${fontName}', ${getComputedStyle(element).fontFamily}`
                console.log(`Schriftart "${fontName}" erfolgreich angewendet (${format}).`)
            } else {
                console.warn('Element nicht gefunden.')
            }
        } catch (error) {
            console.error("Fehler beim Laden der Schriftart:", error)
        }
    }

    function updateTime(element) {
        const now = new Date();
        element.innerHTML = now.getHours().toString().padStart(2, '0') + ':' + now.getMinutes().toString().padStart(2, '0')
    }


})